export default {
  ayaa: 'ayaa.png',
  Champ: 'Champ.png',
  Clap: 'Clap.gif',
  cmonBrug: 'cmonBrug.png',
  EvilMadMan: 'EvilMadMan.png',
  EZY: 'EZY.png',
  FeelsBadMan: 'FeelsBadMan.png',
  FeelsCozyMan: 'FeelsCozyMan.png',
  FeelsEvilMan: 'FeelsEvilMan.png',
  FeelsGoodComfy: 'FeelsGoodComfy.png',
  FeelsGoodMan: 'FeelsGoodMan.png',
  FeelsOkayMan: 'FeelsOkayMan.png',
  FeelsOKMan: 'FeelsOKMan.png',
  FeelsStrongMan: 'FeelsStrongMan.png',
  FeelsWeirdMan: 'FeelsWeirdMan.png',
  gachiGASM: 'gachiGASM.png',
  gachiHYPER: 'gachiHYPER.gif',
  Hmmhm: 'Hmmhm.gif',
  hmmm: 'hmmm.png',
  HYPERS: 'HYPERS.png',
  jesus: 'jesus.png',
  Kappa: 'Kappa.png',
  KEKW: 'KEKW.png',
  KKonaW: 'KKonaW.png',
  LUL: 'LUL.png',
  LULW: 'LULW.png',
  monkaGASP: 'monkaGASP.png',
  monkaHmmm: 'monkaHmmm.png',
  monkaKek: 'monkaKek.png',
  monkaMEGA: 'monkaMEGA.png',
  monkaOMEGA: 'monkaOMEGA.png',
  monkaS: 'monkaS.png',
  monkaW: 'monkaW.png',
  nani: 'nani.png',
  nymnSmug: 'nymnSmug.png',
  OhMy: 'OhMy.png',
  OMEGALUL: 'OMEGALUL.png',
  omegasp: 'omegasp.png',
  PagChomp: 'PagChomp.png',
  peepoEvil: 'peepoEvil.png',
  peePOGGERS: 'peePOGGERS.png',
  peepoHappy: 'peepoHappy.png',
  peepoInspect: 'peepoInspect.png',
  peepoNotes: 'peepoNotes.png',
  peepoRunCry: 'peepoRunCry.gif',
  peepoSus: 'peepoSus.png',
  PensiveCowboy: 'PensiveCowboy.png',
  pepeD: 'pepeD.gif',
  Pepega: 'Pepega.png',
  PepeHands: 'PepeHands.png',
  PepeLaugh: 'PepeLaugh.png',
  PepePoint: 'PepePoint.png',
  pepoG: 'pepoG.png',
  pepoS: 'pepoS.png',
  Pog: 'Pog.png',
  PogChamp: 'PogChamp.png',
  POGGERS: 'POGGERS.png',
  PogU: 'PogU.png',
  rager: 'rager.png',
  RIP: 'RIP.png',
  squadW: 'squadW.png',
  SWEATSTINY: 'SWEATSTINY.png',
  tiny: 'tiny.png',
  WeirdChamp: 'WeirdChamp.png',
  WeirdChampW: 'WeirdChampW.png',
  widePeepoHappyRightHeart: 'widePeepoHappyRightHeart.gif',
  HmmmmLurk: 'lurk.gif',
}
